module.exports = __webpack_public_path__ + "static/scale-model-of-jack-london-square-in-oakland-california-7005c01dd15c6586a5f12e7798b6e9ca.png";